<template>
	<v-container>
		<div v-show="showFilters">
			<!-- Loading component -->
			<v-overlay :value="loadingDataGetServiceProvider ||
					loadingDataGetSalesChannels
					">
				<billing-engine-progress-bar
				:showSpinner="loadingDataGetServiceProvider ||
					loadingDataGetSalesChannels
					"
				/>
			</v-overlay>
			<v-card>
				<v-alert type="error" v-show="alert.show">
					<span v-html="alert.message"></span>
				</v-alert>
				<!-- Primary Filters -->
				<billing-engine-filters-primary
					style="margin: 25px"
					:appNameShort="appNameShort"
					:selectedMandatorId="selectedMandatorId"
					:disabled="disabledDueNotSelectedMandator || disableButtons"
					@emitSelectedValue="changeEmittedValue"
					@emitLoadingVariables="handleLoadingVariables"
					@emitErrorEvent="manageErrorFromFilters"
					@showFilterChanged="showSecondaryFilters = $event"
				/>
				<!-- Secondary Filters -->
				<v-expansion-panels class="secondaryBillingEngineFilter" :disabled="!showSecondaryFilters">
					<v-expansion-panel @change="openCloseCounter += 1" :disabled="disabledDueNotSelectedMandator">
						<v-expansion-panel-header class="secondaryBillingEngineFilter">
							<template v-slot:default="{ open }">
								<v-row no-gutters>
									<v-col cols="4">
										<strong>{{txt.additonalFilters}}</strong>
									</v-col>
								</v-row>
							</template>
						</v-expansion-panel-header>
						<v-expansion-panel-content class="secondaryBillingEngineFilter">
							<billing-engine-filters-secondary
								:appNameShort="appNameShort"
								:selectedMandatorId="selectedMandatorId"
								:openCloseCounter="openCloseCounter"
								:disabled="disabledDueNotSelectedMandator || disableButtons"
								:selectedNationalitiesIso="formState.selectedNationalitiesIso"
								@emitSelectedValue="changeEmittedValue"
								@emitLoadingVariables="handleLoadingVariables"
								@emitErrorEvent="manageErrorFromFilters"
							/>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-card>
		</div>
		<v-btn color="primary"
			class="searchButton"
			@click="submitFilters"
			:disabled="disableButtons"
			v-show="showFilters"
			>{{ txt.btn.searchBtn }}
		</v-btn>
		<v-btn
			class="searchButton"
			v-show="!showFilters"
			@click="showFilterHandling"
			>{{ txt.btn.showFilters }}
		</v-btn>
		<v-btn
			class="searchButton"
			:disabled="disableButtons"
			@click="submitExcelExport"
			v-show="!showFilters"
			>{{ txt.btn.excelExportBtn }}
		</v-btn>
	</v-container>
</template>

<script>
import BillingEngineProgressBar from '../../vueBasics/ProgressCircular.vue'
import BillingEngineFiltersPrimary from './BillingEngineFiltersPrimary.vue'
import BillingEngineFiltersSecondary from './BillingEngineFiltersSecondary.vue'

export default {
	name: 'BillingEngineFilter',
	components: {
		BillingEngineProgressBar,
		BillingEngineFiltersPrimary,
		BillingEngineFiltersSecondary,
	},
	props: {
		appNameShort: {
			type: String,
			required: true,
		},
		disableButtons: {
			type: Boolean,
		},
		showFilters: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			selectedMandatorId: 9999,
			openCloseCounter: 0,
			formState: {
				selectedMandators: [],
				selectedFromDate: new Date().toISOString().substr(0, 10),
				selectedTillDate: new Date().toISOString().substr(0, 10),
				selectedServiceproviders: [],
				selectedProducts: [],
				selectedSalesChannels: [],
				selectedBookings: [],
				selectedOrderIds: '',
				selectedPaymentTransactionIds: '',
				selectedCouponCodes: '',
				// secondary filters
				selectedRegions: [],
				selectedProductSkuFirstParts: [],
				selectedPaymentMethods: [],
				selectedPaymentProviders: [],
			},
			txt: {
				additonalFilters: 'Additional filter options',
				error: {
					generalmessage: 'Error while loading',
					mandator: 'mandators',
					serviceproviders: 'service providers',
					salesChannels: 'sales channels',
					regions: 'regions',
					productSkuFirstParts: 'product sku first parts',
				},
				alert: {
					mandatorEmpty: 'Please select a mandator',
				},
				btn: {
					showFilters: 'Back to search',
					searchBtn: 'Search',
					excelExportBtn: 'Excel Export',
				},
			},
			open: false,
			loadingDataGetServiceProvider: false,
			loadingDataGetSalesChannels: false,
			loadingDataGetRegions: false,
			alert: {
				show: false,
				message: '',
				type: 'info',
			},
			showSecondaryFilters: true,
		}
	},
	watch: {
		'formState.selectedMandators': {
			handler() {
				this.selectedMandatorId = this.formState.selectedMandators[0].value
			},
		},
	},
	methods: {
		changeEmittedValue(changeObject) {
			// look up object literals if the syntax is new, I fancy them over switch case
			const valuesToSet = {
				/* from primary filters */
				mandator: () => { this.formState.selectedMandators = changeObject.values },
				fromDate: () => { this.formState.selectedFromDate = changeObject.values },
				tillDate: () => { this.formState.selectedTillDate = changeObject.values },
				serviceproviders: () => { this.formState.selectedServiceproviders = changeObject.values },
				products: () => { this.formState.selectedProducts = changeObject.values },
				salesChannels: () => { this.formState.selectedSalesChannels = changeObject.values },
				booking: () => { this.formState.selectedBookings = changeObject.values },
				orderIds: () => { this.formState.selectedOrderIds = changeObject.values },
				paymentTransactionIds: () => { this.formState.selectedPaymentTransactionIds = changeObject.values },
				couponCodes: () => { this.formState.selectedCouponCodes = changeObject.values },
				/* from secondary filters */
				productSkuFirstParts: () => { this.formState.selectedProductSkuFirstParts = changeObject.values },
				regions: () => { this.formState.selectedRegions = changeObject.values },
				paymentProviders: () => { this.formState.selectedPaymentProviders = changeObject.values },
				paymentMethods: () => { this.fromState.selectedPaymentMethods = changeObject.values },
			}
			if (typeof valuesToSet[changeObject.filterId] === 'function') {
				valuesToSet[changeObject.filterId]()
			}
		},
		handleLoadingVariables(changeObject) {
			const loadingValuesToSet = {
				serviceproviders: () => { this.loadingDataGetServiceProvider = changeObject.value },
				salesChannels: () => { this.loadingDataGetSalesChannels = changeObject.value },
				regions: () => { this.loadingDataGetRegions = changeObject.value },
			}
			if (typeof loadingValuesToSet[changeObject.filterId] === 'function') {
				loadingValuesToSet[changeObject.filterId]()
			}
		},
		manageErrorFromFilters(errorFromFilter) {
			const errorMessageToSet = {
				mandator: () => { this.setError(this.txt.error.mandator) },
				serviceproviders: () => { this.setError(this.txt.error.serviceproviders) },
				salesChannels: () => { this.setError(this.txt.error.salesChannels) },
				regions: () => { this.setError(this.txt.error.regions) },
				productSkuFirstParts: () => { this.setError(this.txt.error.productSkuFirstParts) },
			}
			errorMessageToSet[errorFromFilter.filterId]()
		},
		setError(filter) {
			// append to the error message or assign it newly depending if there is some other error shown at the moment
			if (this.alert.show) this.alert.message += `${this.txt.error.generalmessage}: <strong>${filter}</strong>. <br>`
			else this.alert.message = `${this.txt.error.generalmessage}: <strong>${filter}</strong>. <br>`
			this.alert.show = true
			this.alert.type = 'error'
			// set the loading variables to false, otherwise the ui is blocked by the spinner
			this.loadingDataGetServiceProvider = false
			this.loadingDataGetServiceProviderCity = false
			this.loadingDataGetRegions = false
			setTimeout(() => this.alert.show = false, 6000)
		},
		async createFilterObject() {
			const filterData = {
				mandator: this.formState.selectedMandators,
				fromDate: this.formState.selectedFromDate,
				tillDate: this.formState.selectedTillDate,
				serviceproviders: this.formState.selectedServiceproviders,
				products: this.formState.selectedProducts,
				salesChannels: this.formState.selectedSalesChannels,
				bookings: this.formState.selectedBookings,
				orderIds: this.arrayifiedOrderIds,
				paymentTransactionIds: this.arrayifiedPaymentTransactionIds,
				couponCodes: this.arrayifiedCouponCodes,
				productSkuFirstParts: this.formState.selectedProductSkuFirstParts,
				regions: this.formState.selectedRegions,
				paymentProviders: this.formState.selectedPaymentProviders,
				paymentMethods: this.formState.selectedPaymentMethods,
			}
			return filterData
		},
		async submitFilters() {
			const filterData = await this.createFilterObject()
			if (!this.formState.selectedMandators.length > 0) {
				this.alert.show = true
				this.alert.message = this.txt.alert.mandatorEmpty
				setTimeout(() => this.alert.show = false, 6000)
			} else {
				this.alert.show = false
				this.selectedFilters = filterData
				this.$emit('submit', filterData)
			}
		},
		async submitExcelExport() {
			const filterData = await this.createFilterObject()
			if (!this.formState.selectedMandators.length > 0) {
				this.alert.show = true
				this.alert.message = this.txt.alert.mandatorEmpty
				setTimeout(() => this.alert.show = false, 6000)
			} else {
				this.alert.show = false
				this.selectedFilters = filterData
				this.$emit('submitExcelExport', filterData)
			}
		},
		showFilterHandling() {
			this.$emit('filtersShallAppear', true)
		},
		arrayifyFreeTextIds(value) {
			const unifiedIds = value.replace(/[\s,;]+/g, ',')
			const idsAsArray = unifiedIds.split(',')
			const idsAsNumbers = idsAsArray.map((orderId) => parseInt(orderId, 10))
			const idsAsNumbersClean = [...new Set(idsAsNumbers.filter((orderId) => !Number.isNaN(orderId)))]
			return idsAsNumbersClean
		},
		arrayifyFreeTextIdsAllowDashAndAlphanumeric(value) {
			const unifiedIds = value.replace(/[^a-zA-Z0-9-]/g, '')
			const idsAsArray = unifiedIds.split(',')
			const idsAsNumbersClean = [...new Set(idsAsArray)]
			idsAsNumbersClean.forEach((element, index) => {
				if (element === '') idsAsNumbersClean.splice(index, 1)
			})
			return idsAsNumbersClean
		},
	},
	computed: {
		disabledDueNotSelectedMandator() {
			if (this.formState.selectedMandators.length > 0) return false
			return true
		},
		arrayifiedOrderIds() {
			return this.arrayifyFreeTextIds(this.formState.selectedOrderIds)
		},
		arrayifiedPaymentTransactionIds() {
			return this.arrayifyFreeTextIdsAllowDashAndAlphanumeric(this.formState.selectedPaymentTransactionIds)
		},
		arrayifiedCouponCodes() {
			return this.arrayifyFreeTextIdsAllowDashAndAlphanumeric(this.formState.selectedCouponCodes)
		},
	},
}
</script>

<style scoped>
form {
  padding: 60px 60px 0px 30px;
}
.searchButton {
  color: #00a0e3;
  margin-left: 25px;
  margin-top: 25px;
}

v-btn {
  padding-left: 25px;
}

.secondaryBillingEngineFilter {
	background-color: #ebebeb;
}

</style>
